// extracted by mini-css-extract-plugin
export default {"wrap":"UserOrderPage_wrap__SmF92","block":"UserOrderPage_block__JeFHG","logo":"UserOrderPage_logo__m6Bv3","btnClose":"UserOrderPage_btnClose__YXZKB"};